export default __webpack_public_path__ + "static/media/ic_eth.68529606.svg";